module.exports = __webpack_public_path__ + "media/images/icons/eu-flag-15c7577e45509e5a67088aa2440d9b1a.svg";